import { HeaderBar } from 'components/city-blocks/header-bar';
import { Footer } from 'components/footer/footer';
import Head from 'next/head';

function Layout({ children }) {
  return (
    <div>
      <Head>
        <link rel='icon' href='/favicon.png' />
        <title></title>
      </Head>
      <main className='flex w-full flex-col'>
        <HeaderBar />
        {children}
        <Footer className='mt-4 md:mt-20' />
      </main>
    </div>
  );
}

export default Layout;
